// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4481":"c747620e61b7645f","7556":"32fafa4be1329333"}[chunkId] + ".js";
};